export default __webpack_public_path__ + "static/media/S-005.9e72a68b.png";